import requestCtxs from '@/sealFilter/requestCtxs'
import { getUserInfo } from "@/common/utils/localStorage.js";

//处理图片数据流
export function ids (data) {
    let userInfo = getUserInfo
    return requestCtxs({
        url: '/core/ttv3/core/datahandle/ebook/search/by/ids',
        method: 'post',
        data
    })
}
//处理图片数据流
export function orderly (data) {
    let userInfo = getUserInfo
    return requestCtxs({
        url: '/core/ttv3/core/datahandle/ebook/search/by/ids/orderly',
        method: 'post',
        data
    })
}



//获取图片集合
export function byid (data) {
    return requestCtxs({
        url: '/core/ttv3/core/datahandle/ebook/search/by/id',
        method: 'post',
        headers: {
            responseType: "arraybuffer",
        },
        data
    })
}

// 首页模糊搜索
export function detail (data) {
    return requestCtxs({
        url: '/core/ttv3/core/datahandle/ebook/search/by/key/detail',
        method: 'post',
        data
    })
}

// 出版社和出版年份检索
export function searchKey (data) {
    return requestCtxs({
        url: '/core/ttv3/core/datahandle/ebook/search/keyword',
        method: 'post',
        data
    })
}

// 问答检索
export function questionQuery (data) {
    return requestCtxs({
        url: '/portal/ttv3/portal/question/answer/query/ebook',
        method: 'post',
        data
    })
}

// 所有数据
export function keyAll (data) {
    return requestCtxs({
        url: '/core/ttv3/core/datahandle/ebook/search/by/key/all',
        method: 'post',
        data
    })
}

//所有馆藏数据
export function keyMyorg(data) {
    return requestCtxs({
        url: '/core/ttv3/core/datahandle/ebook/search/by/key/myorg',
        method: 'post',
        data
    })
}


//新增订购
export function rmdAdd(data) {
    return requestCtxs({
        url: '/portal/ttv3/portal/ebook/rmd/add',
        method: 'post',
        data
    })
}

//取消荐购
export function cancelRmd(data) {
    return requestCtxs({
        url: '/portal/ttv3/portal/ebook/rmd/delete/by/id',
        method: 'post',
        data
    })
}

// 订购列表查询
export function rmdQuery (data) {
    return requestCtxs({
        url: '/portal/ttv3/portal/ebook/rmd/query',
        method: 'post',
        data
    })
}


// 订购数据修改
export function rmdByid (data) {
    return requestCtxs({
        url: '/portal/ttv3/portal/ebook/rmd/update/byid',
        method: 'post',
        data
    })
}
//加入购物车
export function addBuyCart(data) {
    return requestCtxs({
        url: '/portal/ttv3/ebook/library/shoppingcart/insert',
        method: 'post',
        data
    })
}
//移除购物车
export function removeBuyCart(data) {
    return requestCtxs({
        url: '/portal/ttv3/ebook/library/shoppingcart/delete',
        method: 'post',
        data
    })
}

//购物车列表
export function BuyCartlist(data) {
    return requestCtxs({
        url: '/portal/ttv3/ebook/library/shoppingcart/query/bypage',
        method: 'post',
        data
    })
}
//购物车总价和数量
export function totalprice(data) {
    return requestCtxs({
        url: '/portal/ttv3/ebook/library/shoppingcart/query/totalprice',
        method: 'post',
        data
    })
}

//提交订单
export function submitOrder(data) {
    return requestCtxs({
        url: '/portal/ttv3/ebook/library/orderinfo/insert/orderinfo/detail',
        method: 'post',
        data
    })
}
//订单列表
export function orderList(data) {
    return requestCtxs({
        url: '/portal/ttv3/ebook/library/orderinfo/query/bypage',
        method: 'post',
        data
    })
}
//订单审核
export function orderCheck(data) {
    return requestCtxs({
        url: '/portal/ttv3/ebook/library/orderinfo/update',
        method: 'post',
        data
    })
}
//订单详情列表
export function BuyCartDetail(data) {
    return requestCtxs({
        url: '/portal/ttv3/ebook/library/orderdetail/query/bypage',
        method: 'post',
        data
    })
}
//借阅
export function rmdBorrow (data) {
    return requestCtxs({
        url: '/portal/ttv3/portal/ebook/borrow/add',
        method: 'post',
        data
    })
}

//我的借阅
export function queryBorrow (data) {
    return requestCtxs({
        url: '/portal/ttv3/portal/ebook/borrow/query',
        method: 'post',
        data
    })
}
//借阅归还
export function returnBook (data) {
    return requestCtxs({
        url: '/portal/ttv3/portal/ebook/borrow/return/book',
        method: 'post',
        data
    })
}
//AI阅读：文章概述
export function ebookInfo (data) {
    return requestCtxs({
        url: '/core/ttv3/core/ebookaioverview/query/bypage',
        method: 'post',
        data
    })
}
//AI阅读：文章图谱
export function ebookChart (data) {
    return requestCtxs({
        url: '/core/ttv3/core/ebookaipicmap/query/bypage',
        method: 'post',
        data
    })
}
//AI阅读：文章词云
export function ebookWordCloud (data) {
    return requestCtxs({
        url: '/core/ttv3/core/ebookaiwordcloud/query/bypage',
        method: 'post',
        data
    })
}
//AI阅读：文章思维导图
export function ebookMindMap (data) {
    return requestCtxs({
        url: '/core/ttv3/core/ebookaimindmap/query/bypage',
        method: 'post',
        data
    })
}
//AI问答
export function chatQuestion (data) {
    return requestCtxs({
        url: '/core/ttv3/core/ebookaichat/ask/question',
        method: 'post',
        data
    })
}
//AI书目列表
export function AIBooklist (data) {
    return requestCtxs({
        url: '/core/ttv3/core/ebookaioverview/query/ebookpage',
        method: 'post',
        data
    })
}
//AI深度阅读
export function AIDeepRead (data) {
    return requestCtxs({
        url: '/core/ttv3/portal/ai/deep/read/query',
        method: 'post',
        data
    })
}
//寻品列表
export function selectGoodslist(data) {
    return requestCtxs({
        url: '/portal/ttv3/portal/ebook/custom/type/query',
        method: 'post',
        data
    })
}
//寻品列表详情
export function selectGoodsDetail(data) {
    return requestCtxs({
        url: '/portal/ttv3/portal/custom/type/ebook/query',
        method: 'post',
        data
    })
}

//把电子书加入到某个寻品标签
export function addToSelect(data) {
    return requestCtxs({
        url: '/portal/ttv3/portal/custom/type/ebook/add',
        method: 'post',
        data
    })
}
//把电子书从某个寻品标签中删除
export function removeToSelect(data) {
    return requestCtxs({
        url: '/portal/ttv3/portal/custom/type/ebook/delete',
        method: 'post',
        data
    })
}
//获取首页banner
export function bannerlist(data) {
    return requestCtxs({
        url: '/portal/ttv3/portal/banner/pagequery',
        method: 'post',
        data
    })
}
//根据ebookid获取source
export function sourceType(data) {
    return requestCtxs({
        url: '/portal/ttv3/core/datahandle/ebook/search/by/time',
        method: 'post',
        data
    })
}

//二次检索
export function TwoQueryByWord(data) {
    return requestCtxs({
        url: '/portal/ttv3/core/datahandle/ebook/search/keyword',
        method: 'post',
        data
    })
}
//目次检索
export function CatalogQueryByWord(data) {
    return requestCtxs({
        url: '/portal/ttv3/core/datahandle/ebook/search/keyword',
        method: 'post',
        data
    })
}
//科学文库专区
export function kxwkZoneList(data) {
    return requestCtxs({
        url: '/portal/ttv3/outer/api/dock/kxwk/page/query',
        method: 'post',
        data
    })
}

//天津图采会20260423活动，核销码抽奖
export function checkOffcode(data) {
    return requestCtxs({
        url: '/portal/ttv3/portal/sxact/lottery/update',
        method: 'post',
        data
    })
}
//根据核销码抽奖
export function getGif(data) {
    return requestCtxs({
        url: '/portal/ttv3/portal/sxact/gift/random/query',
        method: 'post',
        data
    })
}
//查询剩余礼品数量
export function remainAmount(data) {
    return requestCtxs({
        url: '/portal/ttv3/portal/sxact/gift/query/nums',
        method: 'post',
        data
    })
}
//查询可以抽奖的时间段
export function queryLotteryDrawTime(data) {
    return requestCtxs({
        url: '/portal/ttv3/portal/sxact/gift/query/settings',
        method: 'post',
        data
    })
}
//当前时间是否可以抽奖
export function isLotteryDraw(data) {
    return requestCtxs({
        url: '/portal/ttv3/portal/sxact/gift/valid/time',
        method: 'post',
        data
    })
}

//设置某日多少礼品
//参数{
//     giftDate:抽奖日期
//     giftNums:抽奖数量
//   }
export function setAmountBtDate(data) {
    return requestCtxs({
        url: '/portal/ttv3/portal/sxact/gift/update/giftdate',
        method: 'post',
        data
    })
}
//新增可以抽奖的时间段
// 参数{
//   startTime:抽奖起始时间
//   endTime:抽奖结束时间
// }
export function addLotteryDrawTime(data) {
    return requestCtxs({
        url: '/portal/ttv3/portal/sxact/gift/add/settings',
        method: 'post',
        data
    })
}
//修改可以抽奖的时间段
// 参数：{
//     pkid
//      startTime:抽奖起始时间
//      endTime:抽奖结束时间
//    }
export function updateLotteryDrawTime(data) {
    return requestCtxs({
        url: '/portal/ttv3/portal/sxact/gift/update/settings',
        method: 'post',
        data
    })
}

//查询当前图书是否有分段下载的文件，如果有，则列出来
export function ebookChapter(data) {
    return requestCtxs({
        url: '/portal/ttv3/security/core/resc/chapter/page/query',
        method: 'post',
        data
    })
}







// WEBPACK FOOTER //
// ./src/api/ebook.js